export const TEAM_CREATE_TOOL_NAME = 'TeamCreate'
